var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 517,
    viewBox: "0 0 1920 517",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M627.991 161.936C934.373 -19.9176 2105.35 319.042 2105.35 319.042L2094.02 428.338L-76.5974 330.379C-53.8197 110.658 647.002 204.617 647.002 204.617L627.991 161.936Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M637.153 168.588C943.536 -13.2651 2114.52 325.695 2114.52 325.695L2103.19 434.991L-67.4353 337.031C-44.6576 117.311 656.165 211.269 656.165 211.269L637.153 168.588Z",
    fill: "#2173BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M652.533 178.644C958.915 -3.2094 2129.9 335.751 2129.9 335.751L2118.57 445.046L-52.0554 347.087C-29.2777 127.366 671.544 221.325 671.544 221.325L652.533 178.644Z",
    fill: "#DA1F3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M669.109 187.679C975.496 5.83224 2146.47 344.817 2146.47 344.817L2135.14 454.113L-35.4828 356.107C-12.7003 136.387 688.12 230.361 688.12 230.361L669.109 187.679Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.7f278633af378ee03b52be4174d35092.svg";
export { ForwardRef as ReactComponent };